module.exports = __webpack_public_path__ + "static/img/top.f4fe59a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top.png
// module id = LP6M
// module chunks = 1